import { getField, updateField } from "vuex-map-fields";
import Cookies from "js-cookie";
export default {
    namespaced: true,
    state: {
        inputSearchQuery: '',
        Products:[],
        skuParams:null,
        show: false,
        type: 'success',
        message: '',
        _timeout: null, // It's better to keep the timeout within the store state
        isQueryType: "search"
    },
    actions: {
        //If you're trying to activate Taia from outside of anything served by layout–app.js you need to
        // use this sort of window.postMessage to open the dialog. See BuyBox.vue for an example.
        updateInputSearchQuery({ commit }, payload) {
            let inputText = payload?.query ?? ''
            let givenQueryType = payload?.type ?? 'search';
            commit('UPDATE_SEARCH_QUERY', inputText);
            commit('UPDATE_GIVEN_TYPE', givenQueryType);
        },
        sendMessageToChatbot({ commit }, givenValue) {
            commit('SEND_MESSAGE_TO_CHATBOT',givenValue);
        },
        setProducts({state,commit},payload) {
            commit('SET_PRODUCTS',payload);
            return true
        },
        open({state, commit, dispatch },payload ) {
            commit('SET_TYPE', payload.type);
            commit('SET_MESSAGE', payload.message);
            commit('SET_SHOW', true);
            if (typeof window !== 'undefined' && window.innerWidth >= 768) {
                const header = document.getElementById('site-navigation');
                if (header) {
                    header.style.zIndex = '99999';
                }
            }
            clearTimeout(state._timeout);
            const timeout = setTimeout(() => {
              dispatch('close');
            }, 3000);
            commit('SET_TIMEOUT', timeout);
          },
          close({ state,commit }) {
            commit('SET_SHOW', false);
            if (typeof window !== 'undefined' && window.innerWidth >= 768) {
                const header = document.getElementById('site-navigation');
                if (header) {
                    header.style.zIndex = '';
                }
            }
            clearTimeout(state._timeout);
            commit('SET_TIMEOUT', null);
          }
    },

    mutations: {
        updateField,
        UPDATE_SEARCH_QUERY(state, value) {
            state.inputSearchQuery = value
        },
        SET_PRODUCTS(state,value) {
            state.Products = value.data || [];

            if(state.Products.length > 0) {
                state.skuParams =  state.Products
                                    .map(p => `skus=${encodeURIComponent(p.sku)}`)
                                    .join('&');
                Cookies.set('skuParams', state.skuParams, { path: '/' });
            }

        },
        SET_SHOW(state, show) {
            state.show = show;
        },
        SET_TYPE(state, type) {
        state.type = type;
        },
        SET_MESSAGE(state, message) {
        state.message = message;
        },
        SET_TIMEOUT(state, timeout) {
        state._timeout = timeout;
        },
        UPDATE_GIVEN_TYPE(state,givenType) {
        state.isQueryType = givenType;
        },
        SEND_MESSAGE_TO_CHATBOT(state, givenData) {
            let {type,payload } = givenData
            window.postMessage (
                {
                    source: 'TAIA_CHATBOT',
                    type,
                    payload,
                },
                );
        }
    },

    getters: {
        getField,
    }
}